<template>
  <div class="credit">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @departmentChange="departmentChange"
      @partnerChange="partnerChange"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'isReturnMoney'">
              {{ isReturnMoneyData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.type === 'seq'">{{ scope.row.index }}</span>
            <span v-else-if="item.field == 'isDirectDeliver'">
              <div v-if="scope.row.isDirectDeliver == '1'">
                {{ $t('addSupplierDelivery.option.direct') }}
              </div>
              <div v-if="scope.row.isDirectDeliver == '0'">
                {{ $t('addSupplierDelivery.option.notDirect') }}
              </div>
            </span>
            <span v-else-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/purchaseReturn.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import status from '@/common/js/status';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  // ============ sunxueping  ============
  import tableMixins from '@/common/mixins/table.js';
  // ================================================
  export default {
    components: {
      SiruiTable,
      SiruiSearch,
      BatchConfirmDialog,
    },
    name: 'purchaseReturnList',
    mixins: [tableMixins],
    data() {
      return {
        load: false,
        img: './static/img/tips.png',
        query: {
          returnNo: null,
          contractNo: null,
          returnSalesman: null,
          isReturnMoney: null,
          returnDepartmentCode: null,
          partnerCode: null,
          partnerName: null,
          freightTaker: null,
          returnMethod: null,
          returnOperator: null,
          outboundStorage: null,
          businessInboundNo: null,
          businessInboundBatchNo: null,
          quantityFlag: null,
          returnQuantity: null,
          returnStatus: null,
          originDocNo: null,
          voucherNo: null,
        },
        partnerTypeList: [], // 合作伙伴类型下拉
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        freightTakerList: [], //运费承担
        requestStatusList: [
          { label: '审批中', value: 'ZT02' },
          { label: '已保存', value: 'ZT06' },
          { label: '已确认', value: 'ZT03' },
          { label: '已驳回', value: 'ZT05' },
          { label: '已审核', value: 'ZT07' },
          { label: '已冲销', value: 'ZT08' },
        ], //申请状态下拉列表
        isDirectDeliverList: [
          { label: this.$t('addSupplierDelivery.option.direct'), value: '1' },
          { label: this.$t('addSupplierDelivery.option.notDirect'), value: '0' },
        ],
        returnMethodList: [], //退换货方式
        rowData: {}, //被选中的列
        isReturnList: [
          { value: 1, label: '退货' },
          { value: 0, label: '换货' },
        ],
        isReturnData: ['换货', '退货'],
        isReturnMoneyList: [
          { value: 1, label: '是' },
          { value: 0, label: '否' },
        ],
        isReturnMoneyData: ['否', '是'],
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'returnNo',
            title: 'purchaseReturn.search.returnNo',
            visible: true,
          },
          {
            field: 'contractNo',
            title: 'purchaseReturn.search.contractNo',
            visible: true,
          },
          { field: 'kindName', title: 'purchaseReturn.search.isReturn', visible: true },
          {
            field: 'outboundStorageName',
            title: 'purchaseReturn.search.outboundStorageCode',
            visible: true,
          },
          { field: 'isReturnMoney', title: 'purchaseReturn.search.isReturnMoney', visible: true },
          {
            field: 'isDirectDeliver',
            title: 'purchaseReturn.search.isDirectDeliver',
            visible: true,
          },
          {
            field: 'returnDepartmentName',
            title: 'purchaseReturn.search.departmentCode',
            visible: true,
          },
          { field: 'partnerName', title: 'purchaseReturn.search.partnerCode', visible: true },
          { field: 'freightTakerName', title: 'purchaseReturn.search.freightTaker', visible: true },
          { field: 'returnMethodName', title: 'purchaseReturn.search.returnMethod', visible: true },
          {
            field: 'businessInboundNo',
            title: 'purchaseReturn.search.businessInboundNo',
            visible: true,
          },
          {
            field: 'businessInboundBatchNo',
            title: 'purchaseReturn.search.businessInboundBatchNo',
            visible: true,
          },
          { field: 'returnQuantity', title: 'purchaseReturn.search.returnQuantity', visible: true },
          {
            field: 'matchedAavailableQuantity',
            title: 'purchaseReturn.form.goodList.invoiceQuantity',
            visible: true,
          }, //已匹配数量
          {
            field: 'matchAvailableQuantity',
            title: 'purchaseReturn.form.goodList.nonInvoiceQuantity',
            visible: true,
          }, //可匹配数量
          {
            field: 'returnStatus',
            title: 'purchaseReturn.search.returnStatus',
            visible: true,
            dictType: 'purchase_return_status',
          },
          {
            field: 'accountingStatus',
            title: 'purchaseReturn.search.accountingStatus',
            visible: true,
            dictType: 'post_status',
          },
          {
            field: 'voucherNo',
            title: '凭证号',
            visible: true,
          },
          {
            field: 'returnSalesmanName',
            title: 'purchaseReturn.search.returnSalesmanNo',
            visible: true,
          },
          {
            field: 'returnOperatorName',
            title: 'purchaseReturn.search.returnOperatorNo',
            visible: true,
          },
          // 销售退货单号 sxp add TAPDID1001896 20210325
          { field: 'originDocNo', title: 'purchaseReturn.search.originDocNo', visible: true },
        ],
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          // {
          //   prop: "isReturn",
          //   name: this.$t("purchaseReturn.search.isReturn"),
          //   type: "select",
          //   placeholder: this.$t("purchaseReturn.search.isReturnPlaceholder"),
          //   options: this.isReturnList
          // },
          {
            prop: 'returnNo',
            name: this.$t('purchaseReturn.search.returnNo'),
            type: 'input',
          },
          {
            type: 'searchTableSpec',
            prop: 'contractNo',
            isMultiple: true,
            name: this.$t('purchaseReturn.search.contractNo'),
            searchType: 'contract',
            extraData: {
              contractCategory: 'purchase',
              dataGroup: this.$globalVar.dataGroup,
            },
          },
          {
            prop: 'returnDepartmentCode',
            name: this.$t('purchaseReturn.search.departmentCode'),
            placeholder: this.$t('purchaseReturn.search.departmentCodePlaceholder'),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            changeMethod: 'departmentChange',
            clearable: false,
          },
          {
            type: 'searchTableSpec',
            prop: 'partnerCode',
            isMultiple: true,
            name: this.$t('purchaseReturn.search.partnerCode'),
            searchType: 'supplier',
            extraData: {
              departmentCode: this.query.returnDepartmentCode,
            },
            changeMethod: 'partnerChange',
            currentValue: this.query.partnerName,
          },
          {
            type: 'searchTableSpec',
            prop: 'returnSalesman',
            isMultiple: true,
            name: this.$t('purchaseReturn.search.returnSalesmanNo'),
            searchType: 'personnel',
          },
          {
            prop: 'isReturnMoney',
            name: this.$t('purchaseReturn.search.isReturnMoney'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('purchaseReturn.search.isReturnMoneyPlaceholder'),
            options: this.isReturnMoneyList,
          },
          {
            prop: 'freightTaker',
            name: this.$t('purchaseReturn.search.freightTaker'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('purchaseReturn.search.freightTakerPlaceholder'),
            options: this.freightTakerList,
          },
          {
            prop: 'returnMethod',
            name: this.$t('purchaseReturn.search.returnMethod'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('purchaseReturn.search.returnMethodPlaceholder'),
            options: this.returnMethodList,
          },
          {
            type: 'searchTableSpec',
            prop: 'returnOperator',
            isMultiple: true,
            name: this.$t('purchaseReturn.search.returnOperatorNo'),
            searchType: 'personnel',
          },
          {
            type: 'searchTableSpec',
            prop: 'outboundStorage',
            isMultiple: true,
            name: this.$t('purchaseReturn.search.outboundStorageCode'),
            searchType: 'warehouse',
          },
          {
            prop: 'businessInboundNo',
            name: this.$t('purchaseReturn.search.businessInboundNo'),
            type: 'input',
            placeholder: this.$t('purchaseReturn.search.businessInboundNoPlaceholder'),
          },
          {
            prop: 'businessInboundBatchNo',
            name: this.$t('purchaseReturn.search.businessInboundBatchNo'),
            type: 'input',
            placeholder: this.$t('purchaseReturn.search.businessInboundBatchNoPlaceholder'),
          },
          {
            // 退货数量
            type: 'selectInput',
            prop: ['quantityFlag', 'returnQuantity'],
            name: this.$t('purchaseReturn.search.returnQuantity'),
            options: [
              { value: 1, label: '大于' },
              { value: 2, label: '小于' },
              { value: 3, label: '不等于' },
              { value: 4, label: '等于' },
            ],
          },
          {
            prop: 'returnStatus',
            name: this.$t('purchaseReturn.search.returnStatus'),
            type: 'dict',
            clearabled: true,
            placeholder: this.$t('purchaseReturn.search.returnStatusPlaceholder'),
            dictType: 'purchase_return_status',
          },
          {
            prop: 'isDirectDeliver',
            name: this.$t('purchaseReturn.search.isDirectDeliver'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('purchaseReturn.search.isDirectDeliverPlaceholder'),
            options: this.isDirectDeliverList,
          },
          {
            // 入账状态
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('paymentList.table.accountingStatus'),
            dictType: 'post_status',
          },
          {
            // 销售退货单号 sxp add TAPDID1001896 20210325
            prop: 'originDocNo',
            name: this.$t('purchaseReturn.search.originDocNo'),
            type: 'input',
            placeholder: this.$t('purchaseReturn.search.originDocNoPlaceholder'),
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getDic();
      this.getData();
      this.getButtonList();
      this.initDepartment();
    },
    methods: {
      departmentChange() {
        // 切换部门
        this.query.partnerCode = this.query.partnerName = null;
      },
      partnerChange(val) {
        let item = val.val;
        if (item && item.length > 0) {
          this.query.partnerCode = item[0].partnerCode;
          this.query.partnerName = item[0].partnerZhName;
        } else {
          this.query.partnerCode = this.query.partnerName = null;
        }
      },
      //业务部门
      initDepartment() {
        const query = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
        };
        this.$axios.post(DataBaseAPI.LIST_COMPANY_API, query).then((res) => {
          if (0 == res.data.code) {
            this.businessDepartmentList = res.data.data;
            this.getSelectedNode(this.businessDepartmentList, this.businessDepartmentList);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      //获取字典值
      getDic() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 合作伙伴类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'partner_type', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.partnerTypeList = res.data.data; // 下拉
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        //运费承担
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'freight_taker', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.freightTakerList = res.data.data;
            }
          });
        //退换货方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'return_method', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.returnMethodList = res.data.data;
            }
          });
        // //退换货单状态
        // this.$axios.post(DataBaseAPI.DIC_CREDIT_API, {dictType: "request_status", tenantCode}).then(res => {
        //     if (0 == res.data.code) {
        //         this.requestStatusList = res.data.data
        //     }
        // });
      },

      //获取数据
      getData() {
        this.load = true;
        // const { pageNum, pageSize } = this.$refs.siruiTable.page;
        // const params = Object.assign({}, {pageNum, pageSize});
        //const query = this.$refs.siruiSearch.query;
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let query = { ...this.query, pageSize, pageNum };
        // console.log(query)
        query.contractNo =
          query.contractNo && query.contractNo.length > 0 ? query.contractNo[0].contractNo : '';
        query.returnSalesmanNo =
          query.returnSalesman && query.returnSalesman.length > 0 && query.returnSalesman[0].id
            ? query.returnSalesman[0].id
            : ''; //业务员
        query.returnOperatorNo =
          query.returnOperator && query.returnOperator.length > 0 && query.returnOperator[0].id
            ? query.returnOperator[0].id
            : ''; //操作人
        query.outboundStorageCode =
          query.outboundStorage &&
          query.outboundStorage.length > 0 &&
          query.outboundStorage[0].storageCode
            ? query.outboundStorage[0].storageCode
            : ''; //仓库
        delete query.returnSalesman;
        delete query.returnOperator;
        delete query.outboundStorage;
        // query.pageSize = this.$refs.siruiTable.page.pageSize;
        // query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post(API.PURCHASE_RETURN_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.log(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'del') {
          //删除
          //判断按钮类型--删除
          this.del();
        } else if (type === 'edit') {
          if (this.multipleSelection.length === 0) {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.noSelectDel'),
              type: 'error',
            });
          } else if (this.multipleSelection.length > 1) {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.onlyCanSelectNoEdit'),
              type: 'error',
            });
          } else if (
            this.multipleSelection.length === 1 &&
            !(
              this.multipleSelection[0].returnStatus === status.ZT06 ||
              this.multipleSelection[0].returnStatus === status.ZT05
            )
          ) {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.typeSelectEdit'),
              type: 'error',
            });
          } else {
            let path = {
              path: '/purchase/purchaseReturnEdit',
              name: 'purchaseReturnEdit',
              meta: {
                keepAlive: true,
              },
              query: { returnNo: this.multipleSelection[0].returnNo },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        } else if (type === 'doBatchConfirm') {
          this.doBatchConfirm(
            'AE_PO_MTL_RETURN',
            { idList: this.multipleSelection.map((it) => it.id) },
            'idList'
          );
        }
        // ============ sunxueping 添加批量过账 ============
        else if (type == 'syncVoucher') {
          this.syncVoucher();
        } else if (type == 'signSyncVoucher') {
          this.signSyncVoucher();
        }
      },
      // ============ sunxueping 添加批量过账 ============
      syncVoucher() {
        const params = {};
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        params.idList = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (!params.idList.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.batchSyncVoucher(API.PURCHASE_RETURN_VOUCHER, params);
      },
      // 批量标记过账
      signSyncVoucher() {
        const params = {};
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        params.idList = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (!params.idList.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.batchSyncVoucher(API.PURCHASE_RETURN_SIGN_VOUCHER, params);
      },
      //新增
      add() {
        let path = {
          path: '/purchase/purchaseReturnAdd',
          name: 'purchaseReturnAdd',
          meta: {
            keepAlive: true,
            title: '采购退换货新增',
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //删除
      del() {
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        //可删除条件
        let isDelete = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (
            this.multipleSelection[i].returnStatus == 'ZT02' ||
            this.multipleSelection[i].returnStatus == 'ZT03'
          ) {
            isDelete = false;
            break;
          }
        }
        if (isDelete) {
          this.$confirmAction()
            .then(() => {
              let returnNos = [];
              let ids = [];
              this.multipleSelection.map((item) => {
                returnNos.push(item.returnNo);
                ids.push(item.id);
              });
              this.$axios.post(API.DELETE_PURCHASE_RETURN_API, { returnNos, ids }).then((res) => {
                if (0 == res.data.code) {
                  //如果操作成功，直接返回列表
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.getData();
                } else {
                  //如果有错误返回，提示信息
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            type: 'error',
            message: this.$t('applicationCredit.msg.delMessage'),
          });
        }
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/purchase/purchaseReturnEdit',
          name: 'purchaseReturnEdit',
          meta: {
            keepAlive: false,
          },
          query: { returnNo: value.row.returnNo, canEdit: '0' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
